// extracted by mini-css-extract-plugin
export default {"AKCAgilitySCTTab":"AKCAgilitySCTTab_AKCAgilitySCTTab__QJT5K","tabsContent":"AKCAgilitySCTTab_tabsContent__WZi2B","actions":"AKCAgilitySCTTab_actions__GYgij"};